import { del, post } from './httpUtils'

export function uploadProductFile(
  productId: number,
  localeCode: string,
  file: File
) {
  const formData = new FormData()

  formData.set('data[attributes][locale]', localeCode)
  formData.set('data[attributes][file]', file)

  const url = `admin/products/${productId}/uploads`
  return post(url, formData)
}

export function deleteProductFile(productId: number, id: number) {
  return del(`admin/products/${productId}/uploads/${id}`)
}

export function addUserGroup(userId: number, params: any) {
  const formData = new FormData()

  formData.set('data[attributes][group_id]', params.group_id)
  formData.set('data[attributes][additional]', params.additional)

  const url = `/users/${userId}/groups`

  return post(url, formData)
}

export function removeUserGroup(userId: number, groupId: number) {
  return del(`/users/${userId}/groups/${groupId}`)
}
